// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"NotFoundPage_notFoundContainer__XvdQn","columnLeft":"NotFoundPage_columnLeft__pMnuL","columnRight":"NotFoundPage_columnRight__yJKA6"};